<template lang="pug">
yz-filter-menu(:label="$t('panel.panel')" :is-active="isActive" :display-value="displayValue" :disable-apply="!selectedPanel" :loading="loading" :max-height="500" :show-header="false" @update:menu="onMenuOpen" @clear="onClear" @apply="onApply")
  .menu-header.sticky.top-0.z-1
    .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('panel.panel').toLowerCase() }}
    yz-text-field.text-sm.mx-4.mb-1(v-model="searchText" :placeholder="$t('search')" size="lg" @input="onQueryChanged")
    .d-flex.align-center.justify-end.px-4.py-2(v-if="count > pageSize")
      yz-pagination(v-model="page" :page-size="pageSize" :count="count" :loading="loading" arrow, type="item")

    yz-divider

  .scrollable-content
    yz-skeleton-loader.pa-4(v-if="loading" type="text@3")

    div(v-else-if="error")
      .text-center.py-8
        .text-xs.neutral500--text.mb-3 {{ $t('error_message.error_occured') }}
        yz-btn(size="sm" variant="outlined" color="primary" @click="fetchPanels") {{ $t('retry') }}

    div(v-else)
      template(v-if="filteredPanels.length > 0")
        yz-radio-group(v-model="selectedPanel" :spacing="0")
          div(v-for="(panel, index) in filteredPanels" :key="panel.id")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="onSelectPanel(panel.id)")
              yz-radio(:value="panel.id" label="")
              .ml-2 {{ panel.name }}
            yz-divider.my-0(v-if="index < filteredPanels.length - 1")
      template(v-else)
        .text-center.py-8.text-xs.neutral500--text {{ $t('panel.no_items_found') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      panels: [],
      selectedPanel: null,
      searchText: '',
      loading: false,
      isActive: false,
      displayValue: '',
      panelsLoaded: false,
      error: false,
      page: 1,
      pageSize: 10,
      count: 0
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    filteredPanels() {
      return this.panels
    }
  },
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.selectedPanel = null
          this.isActive = false
          this.displayValue = ''
        }
      }
    },
    page() {
      this.fetchPanels()
    }
  },
  methods: {
    onMenuOpen(isOpen) {
      if (isOpen && !this.panelsLoaded) {
        this.fetchPanels()
      }
    },
    onQueryChanged: debounce(function() {
      this.page = 1
      this.fetchPanels()
    }, 750),
    async fetchPanels() {
      this.loading = true
      this.error = false
      try {
        const params = {
          company: this.company.id,
          enabled: true,
          page: this.page,
          page_size: this.pageSize
        }
        if (this.searchText) {
          params.name__contains = this.searchText
        }
        const response = await this.$axios.get('/panels/', { params })
        this.panels = response.data.results || response.data || []
        this.count = response.data.count || 0
        this.panelsLoaded = true
      } catch (error) {
        console.error('Error fetching panels:', error)
        this.panels = []
        this.error = true
      } finally {
        this.loading = false
      }
    },
    onSelectPanel(panelId) {
      this.selectedPanel = panelId
    },
    onClear() {
      this.selectedPanel = null
      this.searchText = ''
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      const panel = this.panels.find(p => p.id === this.selectedPanel)
      this.displayValue = panel ? panel.name : ''

      this.$emit('update:filter', {
        key: 'panel',
        value: this.selectedPanel
      })
    },
    reset() {
      this.onClear()
    },
    async restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.panel) {
        // Make sure panels are loaded first
        if (!this.panelsLoaded) {
          await this.fetchPanels()
        }
        this.selectedPanel = parseInt(params.panel)
        this.onApply()
      }
    }
  }
}
</script>

<style scoped>
.hover-bg:hover {
  background-color: #f5f5f5;
}

.menu-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  overflow: hidden;
}

.scrollable-content {
  max-height: 300px;
  overflow-y: auto;
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #b0b0b0;
}
</style>
